var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyTrustBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 306 519.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.39,
    y: 317.93,
    width: 257.56,
    height: 62.18,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.62,
    y: 327.4,
    width: 10.78,
    height: 44.25,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.93,
    cy: 359.31,
    rx: 5,
    ry: 4.96,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.62,
    y: 327.4,
    width: 10.78,
    height: 44.25,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 306,
    height: 519.39,
    style: {
      fill: "#eeefee",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.91,
    y: 13.34,
    width: 13.34,
    height: 13.34,
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.73 32.89 169.54 32.89 169.54 100.47 148.66 121.35 10.73 121.35 10.73 32.89",
    style: {
      fill: "#a6a3a2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.1,
    y: 13.34,
    width: 13.34,
    height: 13.34,
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.28,
    y: 13.34,
    width: 13.34,
    height: 13.34,
    style: {
      fill: "#e2071a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.46,
    y: 13.34,
    width: 13.34,
    height: 13.34,
    style: {
      fill: "#e2071a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.65,
    y: 13.34,
    width: 13.34,
    height: 13.34,
    style: {
      fill: "#e2071a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.83,
    y: 13.34,
    width: 13.34,
    height: 13.34,
    style: {
      fill: "#ecb505",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.01,
    y: 13.34,
    width: 13.34,
    height: 13.34,
    style: {
      fill: "#ecb505",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.2,
    y: 13.34,
    width: 13.34,
    height: 13.34,
    style: {
      fill: "#ecb505",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.36,68.17v6.19h-12.19v34.31h-7.54v-34.31h-12.24v-6.19h31.97Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5,68.17v5.99h-17.96v11.23h14.15v5.8h-14.15v11.46h17.96v6.02h-25.55v-40.51h25.55Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.53,75.53c-.21.41-.44.7-.71.87-.27.17-.59.25-.97.25s-.79-.14-1.26-.43-1.02-.61-1.65-.97c-.63-.35-1.38-.68-2.23-.97-.85-.29-1.85-.43-3.01-.43-1.05,0-1.96.13-2.73.38-.77.25-1.43.6-1.96,1.05-.53.45-.93.98-1.19,1.61s-.39,1.31-.39,2.06c0,.95.27,1.75.8,2.38.53.64,1.24,1.18,2.12,1.62.88.45,1.88.85,3,1.2,1.12.36,2.27.73,3.43,1.13,1.17.4,2.31.87,3.43,1.4s2.12,1.2,3,2.02c.88.81,1.58,1.81,2.11,2.98.53,1.18.8,2.6.8,4.29,0,1.83-.31,3.54-.94,5.14-.63,1.6-1.54,2.99-2.74,4.17-1.2,1.19-2.68,2.12-4.41,2.8-1.74.68-3.73,1.02-5.97,1.02-1.29,0-2.56-.13-3.81-.38s-2.45-.61-3.6-1.08-2.22-1.03-3.22-1.68-1.89-1.38-2.68-2.19l2.19-3.61c.2-.26.45-.48.74-.66s.61-.27.97-.27c.47,0,.97.19,1.51.57s1.18.81,1.92,1.27c.74.47,1.61.89,2.61,1.27s2.2.57,3.6.57c2.15,0,3.81-.51,4.99-1.53s1.76-2.48,1.76-4.38c0-1.06-.27-1.93-.8-2.61-.53-.67-1.24-1.24-2.12-1.69-.88-.46-1.88-.84-3-1.16-1.12-.32-2.26-.66-3.42-1.04-1.16-.37-2.3-.82-3.42-1.34-1.12-.52-2.12-1.2-3-2.05s-1.58-1.89-2.12-3.15c-.53-1.26-.8-2.81-.8-4.66,0-1.48.29-2.91.88-4.31s1.45-2.64,2.58-3.73c1.13-1.08,2.52-1.95,4.16-2.6,1.64-.65,3.52-.98,5.63-.98,2.39,0,4.59.37,6.61,1.12s3.73,1.79,5.15,3.14l-1.85,3.56v.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.23,68.17v6.19h-12.19v34.31h-7.54v-34.31h-12.24v-6.19h31.97Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.2,51.18c0,.95-.16,1.82-.48,2.62-.32.79-.78,1.48-1.36,2.05s-1.29,1.02-2.11,1.34-1.73.47-2.73.47h-5.05v-12.96h5.05c1,0,1.91.16,2.73.48s1.53.77,2.11,1.34c.59.57,1.04,1.25,1.36,2.05.32.79.48,1.67.48,2.62h0ZM30.68,51.18c0-.71-.1-1.35-.29-1.91s-.47-1.04-.83-1.43-.8-.69-1.31-.9c-.52-.21-1.1-.31-1.74-.31h-2.57v9.13h2.57c.65,0,1.23-.1,1.74-.31.51-.21.95-.51,1.31-.9.36-.39.64-.87.83-1.43.2-.56.29-1.2.29-1.91v-.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2,44.7v1.92h-5.86v3.59h4.62v1.86h-4.62v3.67h5.86v1.93h-8.34v-12.96h8.34Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.38,55.72c.48,0,.9-.08,1.28-.23s.69-.37.95-.65c.26-.28.46-.62.59-1.02.14-.4.21-.85.21-1.34v-7.76h2.46v7.76c0,.77-.13,1.48-.38,2.14-.25.65-.62,1.22-1.09,1.69-.48.48-1.05.85-1.73,1.11-.68.27-1.44.4-2.29.4s-1.61-.13-2.29-.4-1.25-.64-1.72-1.11-.84-1.04-1.09-1.69c-.25-.65-.38-1.37-.38-2.14v-7.76h2.46v7.75c0,.5.07.94.21,1.34s.33.74.59,1.03c.26.28.57.5.95.66.37.16.8.23,1.28.23h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.42,44.7v1.98h-3.98v10.98h-2.46v-10.98h-4v-1.98h10.44Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8,47.06c-.07.13-.14.22-.23.28-.09.05-.19.08-.32.08s-.26-.05-.41-.14-.33-.2-.54-.31-.45-.22-.73-.31c-.28-.09-.61-.14-.98-.14-.34,0-.64.04-.89.12-.25.08-.47.19-.64.34-.17.14-.3.32-.39.52s-.13.42-.13.66c0,.3.09.56.26.76.17.2.4.38.69.52s.61.27.98.39c.37.11.74.23,1.12.36s.75.28,1.12.45c.37.17.69.39.98.65.29.26.52.58.69.95.17.38.26.83.26,1.37,0,.59-.1,1.13-.31,1.65-.2.51-.5.96-.9,1.34-.39.38-.87.68-1.44.9s-1.22.33-1.95.33c-.42,0-.83-.04-1.24-.12-.41-.08-.8-.2-1.18-.35s-.73-.33-1.05-.54c-.33-.21-.62-.44-.87-.7l.71-1.16c.07-.08.15-.15.24-.21.09-.06.2-.09.32-.09.15,0,.32.06.49.18.18.12.39.26.63.41s.52.29.85.41.72.18,1.17.18c.7,0,1.24-.16,1.63-.49s.58-.79.58-1.4c0-.34-.09-.62-.26-.83-.17-.22-.4-.4-.69-.54-.29-.15-.61-.27-.98-.37s-.74-.21-1.12-.33c-.38-.12-.75-.26-1.12-.43-.37-.17-.69-.39-.98-.65-.29-.27-.52-.61-.69-1.01-.17-.4-.26-.9-.26-1.49,0-.47.1-.93.29-1.38s.47-.85.84-1.19c.37-.35.82-.62,1.36-.83s1.15-.31,1.84-.31c.78,0,1.5.12,2.16.36s1.22.57,1.68,1l-.6,1.14v-.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.35,54.6c.13,0,.25.05.35.15l.97,1.03c-.54.65-1.2,1.15-1.98,1.5-.78.35-1.72.52-2.82.52-.98,0-1.86-.16-2.65-.49-.78-.33-1.45-.79-2.01-1.37-.55-.59-.98-1.28-1.28-2.1-.3-.81-.44-1.7-.44-2.66s.16-1.87.49-2.68c.33-.81.79-1.51,1.39-2.09.6-.59,1.31-1.04,2.14-1.37.83-.33,1.75-.49,2.76-.49s1.84.15,2.57.46c.73.31,1.36.72,1.89,1.22l-.82,1.12c-.05.07-.11.13-.19.19s-.18.08-.32.08-.28-.05-.43-.16-.33-.22-.56-.35c-.23-.13-.51-.24-.86-.35-.34-.11-.78-.16-1.31-.16-.62,0-1.19.11-1.71.32s-.97.52-1.34.91-.67.87-.88,1.44c-.21.56-.32,1.2-.32,1.9s.11,1.38.32,1.95.5,1.05.85,1.43.78.69,1.27.89c.49.21,1.01.31,1.57.31.33,0,.64-.02.91-.05.27-.04.52-.09.75-.17.23-.08.44-.18.65-.3s.41-.27.61-.45c.06-.05.12-.1.19-.13.07-.03.14-.05.22-.05h.02Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4,57.66h-2.48v-5.67h-6.2v5.67h-2.48v-12.96h2.48v5.58h6.2v-5.58h2.48v12.96Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.26,55.67h5.29v1.99h-7.75v-12.96h2.46s0,10.97,0,10.97Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.61,57.66h-1.9c-.21,0-.39-.05-.53-.16-.14-.1-.24-.23-.3-.39l-.99-2.64h-5.48l-.99,2.64c-.05.14-.14.26-.29.38-.14.11-.32.17-.53.17h-1.91l5.19-12.96h2.51l5.19,12.96h.03ZM124.05,52.77h4.21l-1.61-4.31c-.07-.19-.15-.42-.24-.68-.09-.26-.18-.54-.26-.85-.09.3-.17.59-.25.85s-.16.49-.24.69l-1.61,4.29h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.27,44.71c.07,0,.14.03.2.05.06.03.11.07.17.12s.12.12.18.2l6.94,8.67c-.02-.21-.04-.41-.05-.61,0-.2,0-.39,0-.56v-7.88h2.17v12.96h-1.27c-.19,0-.36-.03-.48-.09-.13-.06-.25-.17-.38-.32l-6.91-8.63c.02.19.03.38.04.57,0,.19,0,.36,0,.52v7.96h-2.17v-12.96h1.29c.11,0,.2,0,.27,0h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,51.18c0,.95-.16,1.82-.48,2.62-.32.79-.78,1.48-1.36,2.05-.59.57-1.29,1.02-2.11,1.34s-1.73.47-2.73.47h-5.05v-12.96h5.05c1,0,1.91.16,2.73.48.82.32,1.53.77,2.11,1.34s1.04,1.25,1.36,2.05c.32.79.48,1.67.48,2.62h0ZM158.49,51.18c0-.71-.1-1.35-.29-1.91-.19-.56-.47-1.04-.83-1.43s-.8-.69-1.31-.9c-.51-.21-1.1-.31-1.74-.31h-2.57v9.13h2.57c.65,0,1.23-.1,1.74-.31.52-.21.95-.51,1.31-.9.36-.39.64-.87.83-1.43.2-.56.29-1.2.29-1.91v-.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(35.78 478.12) scale(1.05 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 12,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "-.02em"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(42.95 478.12) scale(1.05 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 12,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "0em"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OCUS 50/23 | DEU"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(153.51 478.12) scale(1.05 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 12,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "-.03em"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(161.18 478.12) scale(1.05 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 12,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "0em"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SCHLAN"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(211.9 478.12) scale(1.05 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 12,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "-.02em"
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(221.28 478.12) scale(1.05 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 12,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "0em"
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TES"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(243.38 478.12) scale(1.05 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 12,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "-.09em"
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(250.23 478.12) scale(1.05 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 12,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "0em"
    }
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ".DE")))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(122.93 416.34) scale(1.03 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 16,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: ".02em"
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STUDIE "))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(50.52 432.34) scale(1.03 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 16,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: ".02em"
    }
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KUNDENZUFRIEDENHEI"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(245.65 432.34) scale(1.03 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 16,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "-.04em"
    }
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")))), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 453.05,
    x2: 231,
    y2: 453.05,
    style: {
      fill: "none",
      stroke: "#a6a3a2",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.05,
    y: 317.93,
    width: 257.91,
    height: 62.18,
    style: {
      fill: "#e30613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.04,349.44c0-12.55,10.21-22.79,22.76-22.82,12.11-.03,22.66,10.33,22.68,22.82.02,11.18-8.16,20.52-18.72,22.41-1.3.23-2.65.31-4.01.31-12.49.03-22.74-10.36-22.72-22.72",
    style: {
      fill: "#8acac0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.25,353.22c.1,0,.21.1.27.17l.05.22c.16.07.27.32.3.49l.05-.2c-.23-.54-.3-1.52-.69-1.94-.07.14-.09.37-.02.52l-.1-.02c-.05-.15-.1-.34-.2-.46l-.07.3c.26.11.34.67.4.93M105.95,351.39l.19.05-.07-.12c0-.15-.2-1.46-.37-2.4h-.02c-.09-.53-.17-.93-.19-.95.14-.17-.27-.38-.3-.49.02.22.08.46.19.65-.06.14-.07.53-.01.81h.02c.02.11.05.2.1.25.02.19.17.48.09.66l.13.34-.09.39s.32.75.33.81M132.69,357.07l.36-.23.04-.62-.22-.36-.14.17-.09.4.06.64h0ZM116.51,346.08l.11-.48h-.59c-.35.18-.66.35-.72.41-.08.62.46.57.6.97l-.09.4.31-.03c.06.17.08.36.08.54.18.01.38-.17.48-.31,0-.12,0-.36-.1-.44l.26-.25-.05-.22.14-.17c-.06-.18-.25-.36-.42-.41M126.06,333.02l-.24.15-.17-.15-.14.18c-.18.05-.43.04-.6-.04l-.14.17-.31.03.24-.15c-.19.05-.43.04-.6-.04-.06.12-.05.3,0,.42l.17.14-.04.2.17.14c.19-.03.38-.1.55-.18.47.24,1.95-.21,2.53.08l.12-.08c.21-.44-.33-.72-.48-1.05-.33-.08-1.07-.57-1.06.17M132.95,355.04l-.24.15-.04.2.25.27.04-.62h0ZM124.72,332.97c.41.06,1.06-.26,1.27-.64-.24.06-1.67-.17-1.27.64M112.58,345.93l.24.27.31-.03c.24.22.59.22.88.33,0-.24-.13-.53-.29-.71v-.19h-.71c.08.08.14.18.18.27-.15-.07-.49,0-.62.06M117.22,345.2l-.07-.12c-.11.02-.65.28-1.11.52h.59c.22-.05.47-.21.6-.39M135.8,332.3l-.33.13-.1-.02.17.14.48.11-.22-.37h0ZM134.85,357.89l.09-.08h0l.28-.24-.22-.36-.33.13-.19-.04-.19.37.35.15h.02l.19.08h0ZM136.71,336.71h0l.09.2.08.12.05.22.3.49.17.14.46.21.33-.13-.27-.17-.42-.41-.39-.51-.05-.18h-.02l-.12-.38-.1-.44-.05-.22-.2-.46-.24.15v.42l.19.56.18.38h0ZM134.28,329.54l-.14.17.25.27.17.04h.02l.19.05v-.05h.02l.03-.14-.29-.07-.25-.27h0ZM134.82,332.59l-.05.2.37.19.38.09.16-.28-.36-.19-.51-.02h0ZM138.93,357.8h.05l.39-.1-.27-.17-.22.05-.43.11.44.1h.04ZM132.26,336.71h.02l.24.31.3.49.26.17v-.42l.03-.31-.14-.24h-.02l-.13-.23-.39-.09-.34.13.15.2h.02ZM132.76,335.85l-.2-.05-.31.03v.41l.51.02v-.42h0ZM124.24,330.4c-.11.01-.25.05-.33.13l.27.17-.02.1c.08.1.24.19.37.19l.07-.3c-.11-.05-.31-.16-.34-.29M128.68,350.92l.6.04.63-.06.26-.25.28-.35-.08-.54-.39-.51-.15-.33h-.02l-.11-.24-.16-.66-.22-.37.33-.55-.56-.24.21-.47-.29-.07-.1-.02-.31.45-.13.6.06.64.18.56.24.39h.02l.05.08-.26.25-.23.57v.42l-.04.2-.5.4.17.14.53-.08h-.01ZM124.44,331.75l-.22.05-.14.17c.22,0,.7-.09.79-.34-.07-.31-.35-.02-.43.11M118.12,335.94c0,.13-.09.29-.19.37l.58.14-.16.26h0l.05.23c.09-.08.16-.16.23-.24h-.01c.27-.36.32-.74.59-1.13-.36.11-.74.3-1.1.37M121.71,334.4l-.29-.07c.08-.21-.31-.09-.31.05,0,.03,0,.07.01.1h0c.03.15.13.28.16.44l.17.14c.01.11.05.26.13.34-.14.16-.31.31-.5.4l.15.24-.07.3c-.22.02-.38.22-.55.35h0s-.02.02-.03.03l-.31.03-.17.28-.58-.14.12-.2h-.01l.05-.07-.29-.07-.23.15h0l-.12.08c.45.26.42.92.12,1.28.04.39.13.8.14,1.18.15-.17.24-.45.25-.67l.19.04.05.23.36.19c.22-.16.24-.55.18-.79.17-.06.41-.44.54-.6l.17.14c-.07.3-.18.61-.11.92.25-.2.57-.24.81-.43-.04-.42.17-.85.07-1.24.21-.01.42-.15.54-.33h-.01s.06-.1.07-.15c-.07-.28.11-.59-.01-.84.22-.38.45-.56.7-.88.04-.05.02-.2.01-.36h0c0-.09,0-.19.03-.26-.31-.46-1.14-.07-1.47.17M115.59,369.23s.01-.09,0-.13c-.02-.1-.24-.4-.3-.49l.02-.1c-.89-.58.12-.98.29-1.71-.34-.56-2.02-1.78-2.03-1.84-.93-.4-1.79-.94-2.58-1.6h0c-.24-.2-.46-.41-.68-.63-.08.08-.22.12-.33.13l.07-.3-.17-.14c-.15-.11-.4-.22-.54-.34-.08-.07-.07-.22.04-.2l.04-.2c-.12-.15-.34-.6-.61-1.11h.02c-.48-.89-1.1-1.96-1.56-1.91-.1-.12-.19-.3-.2-.47l-.17-.14c.01-.09,0-.17-.03-.25h0c-.04-.1-.09-.2-.15-.3-.23-.38-1.05-2.03-1.56-3.04h0c-.21-.41-.38-.72-.42-.77l.02.22c-.03-.41-.2-1.46-.32-2.22h0c-.05-.35-.09-.63-.11-.76.42-.59.28-1.33.15-2.01h-.01c-.03-.15-.06-.3-.08-.44.04-.09.35-.6.45-.62,0-.23.23-.34.23-.57l-.15-.24c.14-.34.02-.72-.07-1.06-.08.11-.2.06-.31.03.05-.12.08-.26.11-.41h0c.11-.57.13-1.31.32-1.87.13-.38.31-.64.47-.92h0c.07-.13.14-.25.21-.4.04-.08.05-.2.06-.3l.26-.25c.12-.03.2.19.24.27-.04.17-.06.42-.07.69h0c-.02.42,0,.87.05,1.14l.1-.05c.04.08.11,1.05.1,1.13.14.12.23.35.27.53v.03h0c-.07.59-.54,1.46-.68,2.11l.15.24c.58-.61.45-1.66,1.02-2.26l.22-.05c.36.29.85.2,1.21.5.18.01.38-.17.48-.31,0-.08.02-.15.05-.22.07-.2.18-.37.24-.56.1-.11.23-.25.37-.32-.15.17-.24.45-.27.68-.08.04-.16.09-.22.14,0,0,.38-.2.45-.21.01-.19.11-.42.23-.57l-.06.3.17.14c.64-.41.33-.37.8.08l.05-.2.05.22c.1.11.35.28.48.11.09-.11-.03-.08-.08-.05.44-.55.19-.3.79-.41.15.07.78.36.8.53.05.02.1.05.14.09h.71v-.33c.19-.15.39-.51.38-.75l.39.09.09-.4-.22-.37-1.47-.24c.34-.19.79-.22,1.17-.24l.07.12.6.04c.41.42.7.92,1.27,1.14.24-.03.48-.04.72-.04l.34.29c.25-.18.49-.42.66-.68l-.13-.35.19-.37c-.04-.23-.1-.47-.19-.7h-.01s-.02-.05-.03-.07c.02-.72.73-1.43.8-2.21l.26-.25c-.42-.04-.73.34-1.18.24-.04-.14-.04-.31-.01-.47h0c.02-.12.05-.24.09-.33l.88-.74c-.09-.21.06-.62.18-.79l-.3-.49v-.42c-.72.04-1.27.85-1.99,1.1l-.09.4c-.39.52-1.07.44-1.63.45-.16.22-.47.63-.77.81h-.02c-.08.04-.16.08-.23.08l-.03-.07h0l-.1-.26c.43-.43.47-.89,1.09-1.21l.19-.37-.12-.36c.09-.4.23-.77.3-1.14h0c.06-.27.08-.54.04-.84.27-.14.52-.34.74-.55l.05-.2c.32-.26,1.7-.43,2.09-.24l.12-.08.27.17-.02.1.37.19c.32-.12.65-.22.98-.29v.42l.39.09c.27-.09.53-.21.79-.34l.16-.27-.05-.22c-.24.07-.5.13-.75.14l-.27-.17c.09-.03.2-.07.3-.13h0c.15-.08.3-.19.39-.32l-.17-.14c.42-.27.84-.52,1.21-.86-.27-.03-.58.02-.84.11l-.28.35c-.2.09-.71.07-.92,0l.45-.21.19.04.36-.23c-.08-.1-.23-.2-.36-.19l-.34.13-.17-.15c.02-.28.22-.49.28-.76h0s.01-.07.02-.11l-.27-.17.26-.25c.06-.12.05-.3,0-.42l.24-.15.31-.03c.13-.31.43-.6.76-.65l.04-.2.24-.15-.11-.1h0l-.06-.05.43-.11.02-.1.24-.15c-.19-.38.17-.51.16-.69,1.09-.27,1.92-.82,3.04-.85l.05-.2c.14-.06.56-.42.54-.6-.55.06-.7-.17-.68-.16l.14-.18-.29-.07-.34.13c-.04-.12-.16-.15-.27-.17v-.09c-11.32,1.21-20.35,10.94-20.35,22.66,0,8.44,4.69,15.87,11.55,19.82M128.84,326.72l-.56.05.68.16.94.33.97.23.8.08.85.3.63.36,1,.55-.02.1.97.65.85.3.2.19h0l.39.37-.19.37.59.56.52.86-.48-.12-.34-.29-.31.03v.42l.04.04h0l.44.59.52.85.72.78h.03l.28.6.33-.13.34.29-.22.05.08.55-.19-.05-.19-.04.86.72.17.14.29.07.02.02h.02l.6.69-.3-.33-.17-.14-.19-.04-.17-.15-.06-.03h-.02l-.29-.15-1.19-.59.07.12.15.24.17.14.34.24h.02l.97.69-.04.2-.96.19-.14.17.49.54-.51.92-.14.61h0l-.08.37-.16-.37-.04-.09h-.5l.06.1h0l.25.45.19.18.07.32-.21.47.11.44-.45.21.42.41-.58-.14-.1-.02-.22-.37-.61-.46h.51l.53-.07.21-.47-.49-.53-.29-.07-.46-.21-.51-.02-.33.13-.1-.02-.25-.25h0l-.16-.15-.51-.02-.2.17h-.02l-.17.15-.38.33-.11.49-.33.55-.25.67-.11.5-.02.1h0l-.13.58-.3.45-.52.5-.14.18-.45.63.02.44h.03-.03v.3l.08.64.44.31.48-.31.45-.21.28.59.27.59.23.79h.41l.09-.41.38-.33.05-.2-.03-.32.03-.62.14-.18.16-.27-.22-.37-.02-.02h-.03l-.31-1.11.23-.57.23-.57.04-.54h0l.02-.17h.51l.02.18h0l.04.46-.33.55-.04.62-.02.1.42.83.55.16.54-.08.35-.21.09.17-.22.05-.31.03-.13.09h.06-.06l-.11.07-.24.15.03.32.27.17.02-.1.03.32.12.34-.24.15-.32-.39-.16.27-.07.3.1.44.11.44-.26.25-.04.2-.24.15-.15-.24-.61.47h-.02l-.34.22-.52-.22h-.06l-.36.31-.25-.31h-.03l-.05-.06v-.94l-.06-.64-.19-.04-.42.53.04.74.16.44h.02l.08.23-.45.21-.51-.02-.42.52-.23.57-.38.32-.38.33-.48.3-.53.08-.16.19h0l-.12.15-.58-.14-.38.33.34.29.2.04.45.73-.06.72-.15.65h0v.04l-.54.08-.5-.12h-.03l-.14-.03-.7-.06-.58-.14-.29.23h-.01l-.2.17.08.54-.14.59-.35.65.1.44v.52l.47.11.29.32h0l.19.21h.41l.31-.04.82-.02.24-.15h0l.22-.14.38-.33.23-.57.42-.52.6-.38.4-.43.07-.3.46-.21.72-.04.45-.21.33-.21h0l.14-.09.14.09h0l.38.24.23.37.22.37.63.36.44.31.48.11.2.46-.13.6.42-.53-.1-.44.45-.21.24-.15-.56-.24-.27-.17.04-.2-.17-.14-.32.03-.44-.31-.32-.39-.05-.08h0l-.24-.4-.05-.22.38-.33.17.14.12.25.37.28.44.28h0l.08.05.27.17.44.31.34.29.08.54.34.29.39.51.05.22.18.56h.41l-.03-.33.11-.5.28-.35-.38-.09-.05-.22-.1-.44.36-.23.45-.21h.41l.41-.43.03-.15h0l.03-.14-.32-.39.13-.59-.03-.74.28-.77.03-.15.03-.14.21-.05.53-.08-.12.27-.08.19.28.15.26.19.28-.51h0l.07-.12.02-.1-.22-.36.31-.45.3-.45.17.14.03.32-.11.49.25.26.56.24h.41l.02.02h0l.2.32.05.22-.21.47-.38.33-.22.05h-.51l-.43.09-.48.3-.44.63-.48.3-.03.04h0l-.3.5-.43.11-.11.49.1.44.27.17.3.49h.41l.5-.41.55-.18.43-.11.4-.43.1.02.07.12.08.54-.07.3v.94l-.14.34h0l-.09.22c-.15.07-.27.21-.38.33l-.39-.09c-.56,1.02-1.72.61-2.06.98-.71-.35-2.37-.11-2.08,1.07l-.26.25-.78-.18-.33.13c-.27-.02-.62-.2-.71-.48-.39-.09-1.12,0-1.4-.12l-.15-.24-.31.03c.02-.32.28-.55.3-.87l-.13-.34.09-.4-.21.05-.27-.17c-.19.03-.38.11-.55.18-.23-.12-.86.02-1.13.04-.58-.24-2.56.37-3.12.73l-.19-.05-.08-.12c-.38.02-.72-.07-1.09-.15l-.15-.24c-.22.07-.59.65-.7.88-.5-.07-1.05.24-1.36.62-.02.26-.2.47-.27.72h-.02s-.02.09-.03.15c-.19.33-.89.38-1.24.54l-.19-.05c-.31.05-2.37,1.61-2.71,2.15h0s-.05.09-.05.12c.11.11.26.24.32.39-.12.15-.22.38-.23.57l.15.24c-.07.17-.46.49-.45.63-.12.1-.29.2-.45.21,0,.16.1.34.2.46-.25.57.36.9.77,1.12l.05.22c.22.12.27.41.49.53-.09.11.12.21.03.32l.15.25c.47.01,1.32,1.34,2.55,1.34.81,0,1.5.18,2.29.23,1.23.08,2.11-.44,3.39-.14l.15.25c.26.11,1.07,0,1.35-.1l.17.15.22-.05c.32.27-.95,1.03-.66,1.1l.19.04.07.12.68.16-.14.17.22-.05s-.02.04-.02.07c5.67-1.25,10.58-4.63,13.82-9.26.07-.15.13-.28.17-.34.13-.2.16-.42.3-.59.09-.11.08-.24.19-.37.05-.07.06-.11.08-.19l.03-.13.03-.13-.05.06-.09.12-.17.27-.28.35c-.22.23-.37.46-.56.7l-.42.52c-.13.15-.2,0-.25-.03.39-.44-.64-.25-.7-.3-.33-.28.02-.41-.49-.53l-.07-.12c.19-.4-.08-.75-.42-.83-.07-.11-.14-.21-.19-.32h.02c-.04-.09-.07-.18-.08-.27l-.1-.02c-.17-.27-.35-.71-.62-.88l-.1-.44c.17.11.25.3.42.41l.12-.08.16-.69.18.57.41.41.22.37.29.07.24.27-.07.29h-.02l.17.15-.02.1.29.07.25.27-.02.1.25.27.03.32v.42l.03-.1.5-.4.31-.45.14-.17.4-.56h.02l.04-.06.35-.65.33-.55.25-.67.14-.17.35-.65v-.02h.02l.2-.45.16-.69.05-.2.16-.69.16-.69-.08-.12-.24.15-.2-.05-.1-.44-.16.69-.16.69-.3.45-.2-.04-.07-.12-.14.17-.15-.24-.1-.02-.24-.27-.07-.12.03-.19.33-.43h.18l.27.18.36-.23.31-.45.23-.23h0l.02-.02.22-.05.19-.37.28-.35.02-.1.25-.67.07-.3.23-.57.07.12.02-.1.02-.1.07.12.07.12.14-.17-.05-.22.03-.12.06-.26.05.06c.05-.64.09-1.28.09-1.93,0-11.82-9.19-21.76-20.65-22.84M122.22,331.91l.02-.1c-.07-.03-.15-.05-.24-.05.14-.03.27-.07.38-.13-.08.02-.16-.08-.17-.14.08-.14.24-.26.38-.33-.17,0-.38-.15-.44-.31-.12-.06-.3-.05-.41,0l-.14.17.05-.2-.22.05c-.1.08-.19.24-.19.37l-.24.15.09-.4-.1-.02c-.24.16-.48.37-.79.34.16.32-.13.33.13.76-.04.05-.08.11-.11.17h0c-.05.1-.09.2-.1.3.09.25.38.16.58.14.08-.16.18-.31.3-.45h0c.43-.02.8-.19,1.2-.34M127.07,349.91l.65-.16.3-.45v-.39h-.02l.28-.36-.32-.39-.29-.07-.26.25-.48.31.04.28h.01l.04.24-.42.52.46.22h.01ZM127.81,343.42l.31-.03.36-.23.24-.36.05-.08-.2-.46-.12.07h-.41l-.17-.13-.31.03.03.32-.04.2v.07h0v.44l.25.17h0ZM130.47,335.21c-.09-.05-.23-.01-.31.03l-.18-.76h0l-.03-.12c-.23.12-.57-.03-.8-.08l-.02.1-.17.11-.06.04s-.04-.03-.06-.04h-.02c-.55-.34-.61-.13-.98,0-.12.05-.27.08-.48.09l-.05.2c-.46.4-.64.03-.96.19l-.14.17.07.12-.34.13.07.12-.16.27.19.05c.04.11.15.21.25.27.09.19.07.39-.01.61h0c-.21.52-.75,1.06-.74,1.4l.29.07-.28.26-.38.06-.14.53.27.17c-.33.54-.63.45-.95.84h-.01c-.21.27-.43.76-.66,1.8-.11.48-.11.75-.07.98h.01c.04.26.13.47.15.9l.27.17.22-.05c.06-.13.36-.57.68-1.03h0c.39-.55.82-1.11.93-1.19.28-.07.53.02.79.08.29-.09.5-.63.9-.83l.17.14c.36.05.96-.44,1.27-.64-.12-.05-.2-.19-.26-.33-.02-.05-.03-.1-.04-.14l.16-.28.05.22.17.14.17-.27c-.08-.37.07-.75.15-1.12l.26-.25.16-.69-.13-.34.36-.23c-.1-.12-.15-.25-.16-.38h0c-.03-.45.36-.94.63-1.27l-.05-.22h0ZM124,332.43l.12-.07-.13-.03s-.08-.03-.11-.07h-.01s-.03-.04-.03-.06c-.04.02-.08.05-.12.07h-.05l-.07-.12-.2.13h0l-.03.02-.12.08-.14.18.29.07h0s-.03,0-.05-.01c.09-.15.23-.24.37-.33h.05l.1.03-.12.08-.04.2-.31.03c.15.05.33.06.49.03.02-.01.04-.03.07-.04l.04-.17v-.02ZM123.77,334.15c.06-.12.05-.3,0-.42l-.17-.15.09-.4.34-.13.11-.5c-.05,0-.11.02-.16.04v.03h-.07s-.08.03-.1.06c0,.13-.09.29-.19.37l-.31.03c-.39.31-.05.86.14,1.18l.33-.13v.02ZM122.36,332.73l.17.14.24-.15-.15-.25c-.14.04-.38.16-.53.09l.14-.17-.43.11c-.06.17-.32.28-.48.31.12.1.3.21.46.21.2-.06.41-.15.57-.28M122.4,332.99l-.22.05-.34.13.1.02.22-.05.17.14.17.14.14-.18.14-.17-.17-.14-.21.05h0ZM122.33,329.87l-.33.13v.02h-.01l-.04.17c.28,0,.55.36.69.58l.21-.05c.12-.19.32-.29.5-.4l.04-.2s-.02-.08-.06-.1h-.09s-.04.03-.04.05l-.2-.05h0l-.67-.16h0ZM121.44,333.67l.24-.15.31-.03.12-.08.19.05.1.02.27.17-.12.08h-.41l-.48.31-.31.03-.07-.12.16-.27h0Z",
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "225.24 331.19 226.67 337.06 229.31 337.06 229.31 327.65 197.95 327.65 197.95 329.92 202.47 331.54 202.47 367.68 197.95 368.94 197.95 371.58 229.94 371.58 231.76 360.15 228.96 360.15 224.6 368.04 210.63 368.03 210.63 350.12 218.89 350.12 220.19 355.11 223.01 355.11 223.01 341.56 220.19 341.56 218.89 346.61 210.63 346.62 210.63 331.19 225.24 331.19",
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.59 331.2 275.73 329.92 275.73 327.65 261.36 327.65 261.36 329.92 266.27 331.11 256.27 348.77 246.65 330.93 251.59 329.92 251.59 327.65 233.29 327.65 233.29 329.92 238.22 330.93 250.42 353.5 250.42 367.71 244.55 368.94 244.55 371.58 264.16 371.58 264.16 368.94 258.58 367.71 258.58 352.86 270.59 331.2",
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.84 329.92 193.84 327.65 193.62 327.65 179.27 327.65 179.2 327.65 179.2 329.92 184.53 331.2 184.53 357.36 162.02 327.65 148.92 327.65 148.92 329.92 154.62 331.76 154.62 367.91 149.83 369.16 149.83 371.58 164.03 371.58 164.03 369.16 158.77 367.71 158.77 336.1 186 371.58 188.68 371.58 188.68 331.54 193.84 329.92",
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.34 368.19 98.34 331.18 103.3 329.92 103.3 327.65 90.19 327.65 75.01 360.84 59.55 327.65 45.81 327.65 45.81 329.92 51.52 331.76 51.52 367.47 45.81 369.2 45.81 371.58 61.45 371.58 61.45 369.2 55.66 367.75 55.66 336.32 71.21 371.58 73.92 371.58 90.19 335.95 90.19 367.75 83.67 369.41 83.67 371.58 103.3 371.58 103.3 369.41 98.34 368.19",
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.13 364.77 31.13 371.64 31.71 371.64 31.98 370.63 33.52 370.63 39.93 370.63 40.21 371.64 40.79 371.64 40.79 367.5 40.21 367.5 39.93 368.88 36.07 368.88 36.07 367.11 37.17 366.81 37.17 366.18 34.19 366.18 34.19 366.81 35.3 367.11 35.3 368.88 31.9 368.88 31.9 365.6 33.2 365.28 33.2 364.77 31.13 364.77",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.93,364.27c-2.76,0-5-2.22-5-4.96s2.24-4.96,5-4.96,5,2.22,5,4.96-2.24,4.96-5,4.96",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: ".15px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.75,363.79s.02-.05.04-.06h.05s.07-.07.11-.08h-.04c-.12.04-.33.05-.43.14.03.01.08.02.11,0v.02s-.08.02-.11.04h.07s.15-.06.21-.07M36.35,363.86v-.04l-.02.02s-.32.04-.53.08h0c-.12.02-.21.04-.21.05-.04-.03-.08.06-.11.07.05,0,.1-.02.14-.04.03.01.12.01.18,0h0s.04-.02.05-.02c.04,0,.11-.04.14-.02l.08-.03.09.02s.16-.07.18-.07M37.6,358.02l-.05-.08h-.14l-.08.04.04.03.09.02h.14ZM35.18,361.55l-.11-.02v.13c.04.08.08.14.09.16.14.02.13-.1.21-.13l.09.02v-.07s.07-.02.11-.02c0-.04-.04-.08-.07-.1-.03,0-.08,0-.1.02l-.06-.06h-.05l-.04-.02s-.08.05-.09.09M32.3,359.47l.03.05-.03.04.04.03v.13l.04.03v.07l-.03-.05s0,.09,0,.13c.03.01.07.01.09,0l.03-.04h.04l.03-.03s-.02-.08-.04-.12c.05-.1-.05-.43.02-.55l-.02-.03c-.1-.05-.16.07-.23.1-.02.07-.13.23.04.23M37.16,357.97l.03.05h.04l.06-.04h-.14,0ZM32.29,359.76c0-.09-.06-.23-.14-.28,0,.05-.04.36.14.28M35.15,362.41l.06-.05v-.07s.04-.13.07-.19c-.05,0-.12.03-.16.06h-.04v.16s.04-.03.06-.04c-.02.03,0,.11,0,.14M34.99,361.4l-.03.02s.06.14.11.24v-.13h0s-.04-.1-.08-.13M32.14,357.34l.03.07v.02l.03-.04.02-.11-.08.05h0ZM37.78,357.55l-.02-.02h0l-.05-.06-.08.05.03.07v.04l.07.04.03-.08h0l.02-.04h0ZM33.11,357.15h0l.04-.02.03-.02h.05l.11-.08.03-.04.05-.1-.03-.07-.04.06-.09.09-.11.09h-.04v.02l-.08.03-.1.02h-.05l-.1.06.03.05h.09l.12-.04.08-.04h.01ZM31.53,357.68l.04.03.06-.05v-.04h0v-.05s0,0,0,0h-.03s-.02.05-.02.05l-.06.05h.01ZM32.2,357.56h.04l.04-.07.02-.08-.06-.04-.04.08v.11h0ZM37.77,356.66h0l-.02-.09-.04.06v.05l.04.09.02-.1h0ZM33.11,358.12h0l.07-.06.11-.07.04-.06h-.16l-.05.03h0l-.05.03-.02.08.03.07.04-.03h-.01ZM32.92,358.01v.11h.09v-.11h-.09ZM31.72,359.87s.01.06.03.07l.04-.06h.02s.04-.05.04-.07h-.07s-.03.05-.06.06M36.25,358.9v-.27l-.06-.06-.08-.06-.12.02-.11.09-.07.03h0l-.05.03-.15.03-.08.05-.12-.07-.05.12-.1-.05-.02.06v.02l.09.07.13.03h.14l.12-.05.09-.05h0l.02-.02.06.06.13.05h.13l.09.11.03-.04-.02-.12v.02ZM32.02,359.82v.05l.05.03s-.02-.15-.07-.17c-.07.02,0,.08.02.09M32.94,361.2s.06.02.08.04l.03-.13.06.03h.05s-.03-.05-.05-.06h0c-.08-.06-.16-.07-.25-.13.02.08.07.16.08.24M32.6,360.42v.06c-.06-.02-.04.07,0,.07h.02s.06-.03.1-.04l.03-.04s.06-.01.08-.03c.03.03.07.07.09.11l.05-.03h.07c0,.06.05.1.08.14h0v.07l.07.04-.03.13-.04-.03h-.02v.06l.02.05h0l.02.03c.06-.1.2-.09.28-.03.09,0,.18-.03.26-.03-.04-.03-.1-.05-.15-.06v-.04h.06s.04-.09.04-.09c0,0-.12-.05-.17-.04,0-.04-.1-.09-.13-.12l.03-.04c.07.01.13.04.2.02-.04-.05-.05-.12-.1-.18-.09,0-.19-.04-.27-.02,0-.05-.03-.09-.07-.12h0s-.02,0-.03-.01c-.06.01-.13-.02-.18,0-.08-.05-.12-.1-.19-.15h-.14c-.1.07-.02.25.04.32M30.93,359.79l-.02.04c.27,2.47,2.41,4.54,5,4.54,1.86,0,3.52-1.11,4.39-2.61,0,0-.04-.01-.05-.01-.02,0-.09.05-.11.07h-.02c-.13.19-.22-.03-.38-.07-.12.07-.39.44-.41.44-.09.2-.21.39-.35.56h0s-.09.1-.14.15c.02.02.03.05.03.07h-.06l-.03.02s-.05.09-.07.12c0,.02-.05.01-.04,0h-.04s-.13.06-.24.12h0c-.2.1-.43.24-.42.34-.03.02-.07.04-.1.04l-.03.04h-.06s-.04.02-.07.03c-.08.05-.45.23-.67.34h0c-.09.05-.16.08-.17.09h.05c-.09,0-.32.04-.49.07h0c-.08.01-.14.02-.17.02-.13-.09-.29-.06-.44-.03h0s-.07.02-.1.02c-.02,0-.13-.08-.14-.1-.05,0-.07-.05-.13-.05l-.05.03c-.08-.03-.16,0-.23.01.02.02,0,.04,0,.07-.03-.01-.06-.02-.09-.02h0c-.12-.02-.29-.03-.41-.07-.08-.03-.14-.07-.2-.1h0s-.06-.03-.09-.04c-.02,0-.05-.01-.07-.01l-.06-.06s.04-.04.06-.05c.04,0,.09.01.15.02h0c.09,0,.19,0,.25-.01v-.02s.22-.02.24-.02c.03-.03.08-.05.12-.06h0c.13.02.32.12.46.15l.05-.03c-.13-.13-.37-.1-.5-.22v-.05c.05-.08.03-.19.1-.26,0-.04-.04-.08-.07-.1-.02,0-.03,0-.05-.01-.04-.01-.08-.04-.12-.05-.02-.02-.06-.05-.07-.08.04.03.1.05.15.06,0,.02.02.03.03.05,0,0-.04-.08-.05-.1-.04,0-.09-.02-.13-.05h.07l.03-.02c-.09-.14-.08-.07.02-.17h-.04l.05-.02s.06-.08.02-.11c-.02-.02-.02,0,0,.02-.12-.1-.07-.04-.09-.17.02-.03.08-.17.12-.17,0-.01,0-.02.02-.03v-.16h-.07s-.11-.08-.17-.08l.02-.08-.09-.02-.08.05-.05.32c-.04-.07-.05-.17-.05-.26l.03-.02v-.13c.1-.09.21-.15.26-.28v-.16l.06-.07s-.09-.11-.15-.14l-.08.03-.08-.04s-.1.02-.15.04h0s0,0-.02.01c-.16,0-.32-.16-.49-.18l-.06-.06c0,.09.07.16.05.26h-.1s-.05-.01-.07-.02l-.16-.19s-.14-.01-.17-.04l-.11.06h-.09c0,.16.19.28.24.43l.09.02c.11.08.1.23.1.36.05.04.14.1.18.17h0s.02.04.02.05h-.02l-.06.03c-.1-.09-.2-.1-.27-.24l-.08-.04-.08.03c-.09-.02-.17-.05-.25-.07h0c-.06,0-.12-.02-.19,0-.03-.06-.08-.11-.12-.16h-.04c-.06-.08-.1-.38-.05-.47l-.02-.03.04-.06h.02l.04-.07c-.03-.07-.05-.14-.06-.21h.09l.02-.09c-.02-.06-.05-.12-.07-.17l-.06-.04h-.05c.02.06.03.12.03.17l-.04.06s-.02-.04-.03-.07h0s-.04-.06-.07-.08l-.03.04c-.06-.09-.11-.18-.19-.26,0,.06,0,.13.02.18l.08.06s.02.16,0,.2l-.05-.1v-.04l-.04-.08s-.04.05-.04.08l.03.07-.03.04c-.06,0-.11-.05-.17-.06h-.02l-.04.06-.06-.06s-.07-.01-.09,0l-.03-.05v-.07c-.07-.03-.14-.09-.15-.17h-.04l-.03-.06-.02.02h-.01s-.02-.08-.02-.08h-.02l-.03-.06c-.08.04-.11-.04-.15-.03-.06-.24-.18-.42-.19-.66h-.04s-.09-.13-.13-.13c.01.12-.04.15-.04.15l-.07-.05-.03.08M30.81,358.86l.11.12.04-.15.07-.21.05-.21.02-.17.07-.19.08-.14.12-.22h.02l.14-.21.07-.19.04-.04h0l.08-.08.08.04.12-.13.19-.11-.03.11-.06.07v.07h.1l.13-.11.19-.11.17-.16h0l.13-.06-.03-.07.06-.07v.05l.13-.02v.04l-.02.04.16-.19.03-.04.02-.06h0l.15-.14-.07.07-.03.04v.04l-.04.04h0v.02l-.03.06-.13.26.03-.02.05-.03.03-.04.05-.07h0l.15-.22h.04l.04.22.04.03.12-.11.2.11.14.03h0l.08.02-.08.04h-.02v.12h.02l.1-.07.04-.04h.07l.1.03.1-.02.05.1.09-.09-.03.13v.02l-.09.05-.1.13v-.23s-.11-.05-.11-.05l-.12.11-.02.06-.05.1v.11l.03.07v.02l-.06.05h0l-.03.04v.11l.03.04h0l.03.04.07.08.11.02.12.07.15.05.11.02h.02l.13.03.1.07.11.11.04.03.14.1h.17l.14-.02.07-.1-.07-.1-.04-.1.13-.06.13-.06.17-.05v-.09l-.09-.02-.07-.08h-.25l-.04-.04-.06-.04-.08.05h0l-.24.08-.13-.05-.13-.05h-.16v-.11h.14s.12.06.12.06h.16s.18-.08.18-.08l.04-.12-.02-.12-.05-.08.04-.02v.05l.02.07.02.03h0v.02l.05.05h.07l.04-.06h-.02.07s.08-.04.08-.04l.03.05-.09.07.06.04h.17l.1-.02.06.06h.04l.03.06-.05.03.1.13h0l.05.08-.05.11h0l.07.09-.07.06h0v.02h-.35v.06l.12.09h.16l.1-.04h0l.05-.02.04.1v.11l.11.09.13.05.07.08.07.08.07.1.02.11.04.03h0l.03.03-.03.13.07.08.06-.07v-.04l.17-.1h.16l.14.04h0l.02.12-.03.11h0v.19l-.04.13.05.06h0l.04.05.12-.02.13.03.14.08.1-.02h.11l.02-.1.07-.06h0l.05-.04v-.34l-.04-.05h0l-.03-.05-.07-.08-.13-.05-.12-.09-.08-.13-.09-.09h-.07l-.05-.11v-.16l-.05-.1-.05-.07h0l-.02-.03.02-.03h0l.05-.09.08-.05.08-.05.08-.14.07-.1.03-.11.1-.04.13.03-.12-.09-.1.02-.05-.1-.03-.05-.05.12-.04.06h-.04l-.03.03v.07l-.06.1-.09.07h-.02l-.09.06h-.05l-.07-.07.03-.04.06-.03.06-.08.06-.1h0v-.02s.05-.06.05-.06l.07-.1.06-.07.12-.02.06-.07.11-.09h.05l.12-.05v-.09h-.07l-.11-.02-.08-.06-.02.08h-.05l-.1.03-.05-.08-.05-.1v-.09l-.1-.09h-.06s-.09.06-.09.06l-.13-.03h-.16l-.17-.05h-.06v-.06l-.03-.12.06.03.04.02.03-.06.04-.06-.11-.06h-.03s-.02-.01-.02-.01l-.08.04-.1-.07-.1-.07.03-.04h.07l.11.02.06-.05.05-.12v-.09h0l.07-.05h.05l.1.03.07.08v.16l.02.09.07.1.14.1.07.1h0l.11.07.02.09.11.02.1-.02.04-.06.11-.07v-.09l-.09-.11-.04-.12-.02-.09-.09-.09v-.02l.03-.02.12-.02.07.02h.2l.07.03h0l.05.02s.05.06.07.08l-.02.08c.22.12.13.37.22.45-.08.15-.02.52.24.45l.06.06-.04.17.03.07c0,.06-.04.13-.11.15-.02.08,0,.24-.03.31l-.05.03v.07c-.06,0-.11-.06-.19-.07l-.08.03-.09-.02v.05l-.02.06s.02.08.04.12c-.03.05,0,.19,0,.25-.05.13.08.56.16.68v.04l-.04.02c0,.08-.02.16-.03.24l-.05.03s.14.13.19.15c-.02.11.05.23.14.3.06,0,.1.04.16.06h0s.02.01.03.01c.07.04.08.19.12.27v.04c0,.07.34.52.46.59h0s.02.01.03.01c.02-.02.05-.06.09-.07.03.03.08.05.13.05l.05-.03s.11.1.14.1c.02.03.04.06.05.1.04,0,.08-.02.1-.04.12.05.2-.08.25-.17h.05c.03-.06.09-.07.12-.12.02.02.05-.03.07,0l.05-.03c0-.1.29-.29.29-.56,0-.18.04-.33.05-.5.02-.27-.1-.46-.03-.74l.05-.03c.02-.06,0-.23-.02-.29l.03-.04v-.05c.05-.07.21.21.23.14v-.04l.04-.02.04-.15.04.03v-.05h0c-.27-1.24-.92-2.31-1.95-3.02-.03-.01-.14-.03-.15-.03-.04-.03-.11-.04-.15-.07-.02-.02-.05-.02-.08-.04,0-.01-.02-.01-.04-.02h-.06s0-.01,0-.01l.03.03.06.04.08.06s.1.08.15.12l.12.09v.05c-.1-.09-.06.14-.06.15-.06.07-.09,0-.12.11l-.03.02c-.09-.04-.17.02-.18.09-.02.01-.05.03-.07.04h0s-.04.01-.06.01v.02c-.07.04-.16.08-.2.13l-.1.02s.07-.05.09-.09l-.02-.03-.15-.03.12-.04.09-.09.08-.05.02-.06.06-.05h.06v.02h0l.03-.04h.02l.02-.06.06-.05h.02l.06-.05h.16-.02l-.09-.11-.1-.07-.04-.03-.12-.09h0s-.14-.09-.14-.09l-.12-.07-.15-.06-.04-.03-.14-.08h0l-.1-.05-.15-.03h-.04l-.15-.04-.15-.03-.03.02.03.05v.04l-.11.02.15.03.15.03.1.07v.04l-.04.02.04.03-.05.03v.02l-.06.05-.03.02h-.04l-.09-.08v-.04l.04-.06-.05-.08-.1-.07-.05-.05h0v-.05l-.09-.04-.08-.06h-.02l-.15-.06h-.07l-.13-.06.03-.02h-.04l.03-.02.03-.02-.05-.05-.04-.02h-.03l-.05-.03h0c-.14,0-.28-.06-.42-.06-2.61,0-4.89,2.1-5.13,4.6M32.05,360.31h-.02s0,.03,0,.05c0-.03,0-.06-.03-.08,0,.02-.02.03-.03.04-.03-.02-.06-.05-.07-.08,0,.04-.03.08-.07.1-.01.03-.01.06,0,.09l.04.03h-.04v.04s.06.04.09.04l.03.05-.09-.02v.02s.08.11.07.17c.07-.03.07.03.17-.03,0,0,.02.02.04.02h0s.04.02.07.02c.06-.02.04-.08.03-.13-.03-.02-.07-.04-.1-.06h0c0-.09-.04-.17-.08-.26M36.02,359.25l-.04-.14-.1-.07h-.09l-.08-.06-.09.07-.02.06.06.06.07.1h.06l.05-.02.12.09.05-.1h.01ZM34.59,359.09v-.07l-.06-.08-.08-.05h-.02l-.1.03.02.03v.09l-.03.04v.07h.13s.1.01.1.01l.04-.06h0ZM32.78,358.51v.07l-.17.04h-.03s0,.12-.02.17h.02l.02.04h0v.03h0c-.07.12-.03.14,0,.22,0,.03.02.06.02.11h.04c.09.11,0,.15.04.22l.04.03.03-.02.03.07.03-.02.06.04v-.04s.06-.03.07-.05c.04-.02.09-.01.13,0h0c.11.04.23.16.31.16v-.06l.07.06v.08l.13.03.04-.06c.12.07.1.14.18.21h0c.06.05.17.1.4.15.11.02.17.02.22.02h0c.06-.01.1-.03.2-.04l.04-.06v-.05s-.14-.08-.24-.15h0c-.12-.09-.25-.18-.26-.2,0-.06,0-.12.02-.17-.02-.06-.14-.11-.18-.2l.03-.04c0-.08-.1-.21-.14-.28,0,.03-.04.04-.07.06h-.03l-.06-.04h.05l.03-.05-.06-.04c-.08.02-.17-.01-.25-.03l-.06-.06-.15-.03-.07.03-.05-.08s-.06.03-.08.03h0c-.1,0-.21-.08-.28-.14h-.05v.04ZM32.17,359.92l-.02-.02v.03s0,.02-.02.02h0s0,.02.02.03h0l-.03.03.03.04h0l.02.03.04.03.02-.06h0s-.05-.04-.07-.07h0v-.03l.02.03h.04v.08s0-.07,0-.11v-.02h-.04ZM32.55,359.97s-.07-.01-.09,0l-.03.04-.09-.02-.03-.07-.11-.02v.04h0v.02s0,.02,0,.02c.03,0,.06.02.08.04v.07c.07.08.2.01.27-.03l-.03-.07.02-.02ZM32.24,360.28l.03-.04-.03-.05-.05.03s.03.08.02.11l-.04-.03.02.09s.06.07.07.1c.02-.03.05-.07.05-.1,0-.04-.03-.09-.06-.13M32.29,360.27v.05l.04.07v-.07l.03-.04.03-.04-.04-.03-.04-.03-.03.04v.05h.01ZM31.6,360.28l.03.07h.04s.08-.11.13-.14v-.05s-.07-.07-.1-.11h-.06v.02h.01v.04h-.01l-.03.15v.02ZM32.44,360.48l-.03-.05v-.07l-.02-.03v-.04l.02-.02.04-.06.02.03v.09l.07.1v.07l-.02.02-.06-.04h-.02Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-3)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.09,344.6v.71c-1.23.28-2.25,1.35-2.25,2.81,0,2.24,2.29,3.25,4.23,3.25,2.25,0,4.16-1.23,4.2-3.67.02-1.17-.46-2.1-1.65-2.92v-.12l.54-.55h.11c1.52,1.55,1.69,2.89,1.69,3.96,0,3.49-2.35,5.19-4.89,5.19s-4.95-1.9-4.95-4.92c0-1.03.37-2,1.11-2.78l-1-.31v-.64h2.84",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.23,343.64v-4.11h.56l.29,1.27h5.74c1.72-.03,2.42-1.06,2.45-2.27.03-1.09-.42-2.54-2.83-2.55h-5.36l-.27,1.06h-.57v-2.89h.57l.27,1.06h5.28c2.16,0,3.62,1.02,3.62,3.47,0,1.95-1.02,3.92-3.4,3.92h-5.49l-.29,1.05h-.56",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.26,333c.97,0,2.02-.92,2.02-2.22,0-.73-.41-1.69-1.38-1.75-2.47-.16-2.31,4.48-4.95,4.59-1.98.08-2.82-1.28-2.82-2.59,0-.78.24-1.58.68-2.02l-.56-.27v-.6h2.54v.69c-1.2,0-1.96,1.09-1.98,2.06,0,.92.65,1.36,1.27,1.4,2.11.13,1.88-4.46,4.84-4.73,1.66-.15,3.06,1.08,3.06,3.14,0,.71-.13,1.29-.68,2.04l.56.34v.61h-2.61v-.69h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 10.73,
    y: 13.34,
    width: 13.34,
    height: 13.34,
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.73,
    y: 134.66,
    width: 13.34,
    height: 370.31,
    style: {
      fill: "#a6a3a2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.79,
    y: 13.34,
    width: 13.34,
    height: 491.63,
    style: {
      fill: "#a6a3a2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.8,
    y: 491.63,
    width: 284.4,
    height: 13.34,
    style: {
      fill: "#a6a3a2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.88,
    y: 13.34,
    width: 112.26,
    height: 13.34,
    style: {
      fill: "#a6a3a2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(104.48 176.63) scale(1.02 1)",
    style: {
      fill: "#e2071a",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 47,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "-.05em"
    }
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(132.86 176.63) scale(1.02 1)",
    style: {
      fill: "#e2071a",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 47,
      fontWeight: 700,
      isolation: "isolate"
    }
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(171.91 176.63) scale(1.02 1)",
    style: {
      fill: "#e2071a",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 47,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "-.06em"
    }
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(56.39 222.63) scale(1.02 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 40,
      fontWeight: 700,
      isolation: "isolate"
    }
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KUNDEN-"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(80.25 262.63) scale(1.02 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 40,
      fontWeight: 700,
      isolation: "isolate"
    }
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DIENS"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(201.68 262.63) scale(1.02 1)",
    style: {
      fill: "#1d1d1b",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 40,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "-.06em"
    }
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(53.07 294.63) scale(1.02 1)",
    style: {
      fill: "#ecb505",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 20,
      fontWeight: 700,
      isolation: "isolate"
    }
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REISE &amp;"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(127.19 294.63) scale(1.02 1)",
    style: {
      fill: "#ecb505",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 20,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "-.03em"
    }
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(131.28 294.63) scale(1.02 1)",
    style: {
      fill: "#ecb505",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 20,
      fontWeight: 700,
      isolation: "isolate",
      letterSpacing: "-.05em"
    }
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(143.35 294.63) scale(1.02 1)",
    style: {
      fill: "#ecb505",
      fontFamily: "Lato-Bold, Lato",
      fontSize: 20,
      fontWeight: 700,
      isolation: "isolate"
    }
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OURISMUS")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyTrustBadge);
export default __webpack_public_path__ + "static/media/MoneyTrustBadge.e531edba839408c4568707f057143de4.svg";
export { ForwardRef as ReactComponent };